import { useTheme as useCustomTheme } from '@emotion/react/macro';

export function useTheme() {
  return useCustomTheme();
}

export default useTheme;
